/**
 * Die Reiter der Patientenseite (`/patient/:id?tab=`) und der drei Versorgungs-Detailansichten
 * darin (`versorgungTab`, `versorgungPhmTab`, `verkaufTab`), als Namen fuer die URL.
 *
 * Liegt in `libs/shared`, weil auch die interne Webapp hierher verlinkt (EKV-Detail, Deadletter).
 * Das Backend verlinkt dieselben Namen in seinen Mails (`LeistungserbringerReiter.java`), und sein
 * Assistent liest sie aus gespeicherten Routen (`AssistentSeite.java`) — ein Name hier ist
 * deshalb eine Schnittstelle: umbenennen nur mit beiden zusammen.
 *
 * Die Listen stehen in ANZEIGEreihenfolge; der Guard `versorgung-tab-index.util.spec.ts` haelt sie
 * gegen die Vorlagen.
 */
export const PATIENT_REITER = {
  UEBERSICHT: 'uebersicht',
  VERSORGUNGEN: 'versorgungen',
  /** Die geoeffnete Versorgung — welche, sagt `versorgungId`, `phmVersorgungId` oder `verkaufId`. */
  VERSORGUNG: 'versorgung',
} as const
export type PatientReiter = (typeof PATIENT_REITER)[keyof typeof PATIENT_REITER]
export const PATIENT_REITER_LISTE: readonly PatientReiter[] = [
  PATIENT_REITER.UEBERSICHT,
  PATIENT_REITER.VERSORGUNGEN,
  PATIENT_REITER.VERSORGUNG,
]

/**
 * Ein Name je Reiter, gemeinsam fuer HiMi, Pflegebox und Verkauf — und 1:1 zum Backend-Enum
 * `VersorgungsReiter` (`STATUS_UND_AUFGABEN` → `status`, `VERORDNUNG_UND_GENEHMIGUNG` →
 * `genehmigung`, …). `lieferungen` ist auch der Reiter, der in Haeusern mit Filialabholung
 * „Abholung“ heisst.
 */
export const VERSORGUNG_REITER = {
  STATUS: 'status',
  COCKPIT: 'cockpit',
  ANAMNESE: 'anamnese',
  GENEHMIGUNG: 'genehmigung',
  LIEFERUNGEN: 'lieferungen',
  ABRECHNUNG: 'abrechnung',
  DOKUMENTE: 'dokumente',
} as const
export type VersorgungReiterName = (typeof VERSORGUNG_REITER)[keyof typeof VERSORGUNG_REITER]

const R = VERSORGUNG_REITER
export const HIMI_VERSORGUNG_REITER: readonly VersorgungReiterName[] = [
  R.STATUS,
  R.COCKPIT,
  R.ANAMNESE,
  R.GENEHMIGUNG,
  R.LIEFERUNGEN,
  R.ABRECHNUNG,
  R.DOKUMENTE,
]
export const PHM_VERSORGUNG_REITER: readonly VersorgungReiterName[] = [
  R.STATUS,
  R.COCKPIT,
  R.GENEHMIGUNG,
  R.LIEFERUNGEN,
  R.ABRECHNUNG,
  R.DOKUMENTE,
]
export const VERKAUF_REITER: readonly VersorgungReiterName[] = [R.STATUS, R.COCKPIT, R.LIEFERUNGEN, R.ABRECHNUNG]
